import AccountOutlined from '../../src/legacy/AccountOutlined.tsx';
export default AccountOutlined;
